export const getViewport = (pdfPage: any, scale: number) => {
    let viewport = {
        width: 0,
        height: 0,
    };
    viewport = pdfPage.getViewport({ scale });

    return viewport;
};

export function getScaleByWidth(pdfPage: any, width: number): number {
    // 初始化时自动匹配最佳比例
    const viewport = getViewport(pdfPage, 1);
    // toFixed 为4舍5入，为了防止入后变大，先减去0.005
    const scale = Number((width / viewport.width - 0.005).toFixed(2));
    return scale;
}
